export default __webpack_public_path__ + "static/media/CartaoCliente.8848fe98.svg";